import React, { useState, useEffect, useContext } from 'react';
import Context from "../../context/context";
import classnames from 'classnames';


const BookingLink = props => {

  const { hash} = props;
  const {activeFilters} = useContext(Context);
  const [loading, setLoading] = useState(false);

  const handleSideBarOpen = (hash) => {
    setLoading(true);
    let gdEventInfo = document.getElementById('event-sidebar');
    let gdEventInfoBg = document.getElementById('event-sidebar-bg');
    gdEventInfo.innerHTML = '<div class="loading">Loading</div>';
    gdEventInfo.classList.add('active');
    gdEventInfoBg.classList.add('active');

      fetch(base_url + 'ajax/booking_sidebar/' + hash + '/').then(res => res.json()).then(
        (response) => {
          setLoading(false);
          if (response.sidebar) {

            gdEventInfo.innerHTML = response.sidebar;

            let swiper = gdEventInfo.querySelector('.sidebar-dates');
            let next = gdEventInfo.querySelector('.swiper-next');
            let prev = gdEventInfo.querySelector('.swiper-prev');
            var date_swiper = new Swiper(swiper, {
              slidesPerView: 'auto',
              slidesPerGroupAuto: true,
              spaceBetween: 0,
              mousewheel: true,
              direction: 'vertical',
              slideToClickedSlide: false,
              freeMode: true,
              preventClicks: true,
              a11y: false,
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
            });
          }
          else if (response.message) {
            setLoading(false);
            gdEventInfo.classList.remove('active');
            gdEventInfoBg.classList.remove('active');
            alert(response.message);
          }
          else {

          }
        }
      )
    }


    if (hash !== undefined) {

      return (
        <div

          className={classnames('button button-black', {
            loading: loading
          })}
          onClick={() => handleSideBarOpen(hash)}>
          {loading ? "Loading" : "Quick Book"}

        </div>
      )
    }
    else {
      return null;
    }





}

export default BookingLink;
